import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'
import {config} from '../../../../config'
import {PammOfferType} from '../../../../graphql/types'
import {ActionButton, Actions} from './OfferCardActions.styled'

type OfferCardActionsProps = {
  offer: PammOfferType
}

/**
 * Copy Link action for an offer card. Copies the offer's join link
 * (`?pammManager=&pammOffer=`) to the clipboard.
 *
 * @param offer - The PAMM offer whose join link the action operates on.
 */
export const OfferCardActions = ({offer}: OfferCardActionsProps) => {
  const joinLink = `${config.frontendUrl}?pammManager=${offer.skygroundAccountId}&pammOffer=${offer.id}`

  return (
    <Actions>
      <CopyToClipboard text={joinLink}>
        <ActionButton variant="outlined" size="small" startIcon={<FileCopyOutlined />}>
          <Trans {...messages.copyLink} />
        </ActionButton>
      </CopyToClipboard>
    </Actions>
  )
}
